import React,{useEffect,useRef} from 'react';
let loading;
export function loadTurnstile(){
  if(window.turnstile)return Promise.resolve(window.turnstile);
  if(loading)return loading;
  loading=new Promise((resolve,reject)=>{
    const script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;
    const timer=setTimeout(()=>fail(),15000);
    const fail=()=>{clearTimeout(timer);script.remove();loading=null;reject(new Error('No se pudo cargar la verificación. Comprueba tu conexión o los bloqueadores del navegador.'));};
    script.onerror=fail;script.onload=()=>{clearTimeout(timer);window.turnstile?resolve(window.turnstile):fail();};document.head.appendChild(script);
  });return loading;
}
export default function TurnstileWidget({siteKey,onToken,onError}){
  const element=useRef();const callbacks=useRef({onToken,onError});callbacks.current={onToken,onError};
  useEffect(()=>{
    let alive=true,widget,api;
    loadTurnstile().then(turnstile=>{
      if(!alive)return;api=turnstile;
      widget=api.render(element.current,{sitekey:siteKey,action:'public_control',language:'es',theme:'auto',retry:'never','refresh-expired':'manual','refresh-timeout':'manual',
        callback:token=>{if(alive)callbacks.current.onToken(token);},
        'expired-callback':()=>{if(alive){callbacks.current.onError('La verificación venció. Intenta nuevamente.');}},
        'timeout-callback':()=>{if(alive)callbacks.current.onError('La verificación tardó demasiado. Intenta nuevamente.');},
        'error-callback':code=>{if(alive){const reference=/^\d{6}$/.test(String(code))?` (Cloudflare ${code})`:'';callbacks.current.onError(`No se pudo completar la verificación${reference}. Intenta nuevamente.`);}}});
    }).catch(e=>{if(alive)callbacks.current.onError(e.message);});
    return ()=>{alive=false;if(api && widget!==undefined)api.remove(widget);};
  },[siteKey]);
  return <div ref={element} />;
}
